export const GROUP_DETAIL_COPY = {
  BACK_LABEL: 'Squads',
  LEADERBOARD_TITLE: 'LEADERBOARD',
  FUTURES_HIDDEN_BANNER: 'Winner & top-scorer picks stay hidden until the first match kicks off.',
  SEARCH_PLACEHOLDER: 'Search squad members',
  SEARCH_ACCESSIBILITY_LABEL: 'Search squad members by name',
  SEARCH_EMPTY_LABEL: 'No members found for this search.',
  EMPTY_TITLE: 'Squad not found',
  EMPTY_SUBTITLE: 'This squad may have been removed or the link is invalid.',
  ERROR_TITLE: "Couldn't load squad",
  ERROR_SUBTITLE: 'Check your connection and try again.',
  ERROR_RETRY: 'Go back',
  LEAVE_SQUAD_LABEL: 'Leave squad',
  SQUAD_NAME_SAVED: 'Squad name saved',
} as const;

export const ACCOUNTS_USER_QUERY_KEY = ['accounts', 'user'] as const;

/**
 * Below this member count everyone fits on screen with little scrolling, so the
 * always-visible "your standing" bar would be redundant clutter — only show it
 * for larger squads (or whenever the member is off the fetched page slice).
 */
export const SELF_BAR_MIN_MEMBERS_TO_SHOW = 6;
